module.exports = __webpack_public_path__ + "img/kjyq.fa18f5ab.jpg";